import { addToFiles } from "../api/file";

const addFileToFiles = (id, files) => {
  return (dispatch) =>
    addToFiles(id, files)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .catch((err) => {
        alert("Error when adding file", err.message);
        console.error(err);
      });
};

export { addFileToFiles };
